
import { Options, Vue, prop } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import XLSX from "xlsx";
import { formatDateNormal } from "@/app/infrastructures/misc/Utils";
import {
  HandoverV2Detail,
  HandoverV2DetailStt
} from "@/domain/entities/HandoverV2";

class Props {
  modelValue = prop<string>({ default: "" });
  isScanning = prop<boolean>({ default: false });
  isDuplicateScan = prop<boolean>({ default: false });
  lastScanRow = prop<HandoverV2Detail>({
    default: () => new HandoverV2Detail(),
    type: Object
  });
  failedScans = prop<HandoverV2DetailStt[]>({
    default: () => [],
    type: Array
  });
}

@Options({
  components: { Skeleton },
  emits: ["enter", "focus", "blur", "update:modelValue", "download-failed"],
  watch: {
    isScanning: "onIsScanningChange"
  }
})
class ScanhandoverTopPanel extends Vue.with(Props) {
  get sttNoInputValueModel() {
    return this.modelValue;
  }

  set sttNoInputValueModel(value: string) {
    this.$emit("update:modelValue", value);
  }

  mounted() {
    if (this.isScanning) {
      (this.$refs.scanInputHandover as any)?.focus?.();
    }
  }

  XLSX = XLSX;
  downloadExcel() {
    const data = this.XLSX.utils.json_to_sheet(
      this.failedScans.map((d) => ({
        [this.$t("handoverV2.update.common.sttNo")]: d.sttNo,
        [this.$t("handoverV2.update.common.reason")]: d.message
      }))
    );
    const timestamp = formatDateNormal(new Date(), "YYYYMMDDHHmm");
    const wb = this.XLSX.utils.book_new();
    this.XLSX.utils.book_append_sheet(wb, data, "handover_scan_failed");
    this.XLSX.writeFile(wb, "handover_scan_failed.xlsx");
  }

  onIsScanningChange(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        (this.$refs.scanInputHandover as any)?.focus?.();
      });
    }
  }

  onEnter(value: string) {
    this.$emit("enter", value.trim());
  }
}

export default ScanhandoverTopPanel;
